import { useAtom } from 'jotai'
import * as React from 'react'
import { Index, useSearchBox } from 'react-instantsearch-hooks-web'

import styled from 'styled-components'
import { rwMobileSearchAtom } from '../../atoms/Notifications'
import UserHits from './UserHits'
import VideoHits from './VideoHits'

const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-height: 65vh;
  overflow: scroll;
`

const NoResults = styled.div`
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  color: white;

  // mobile
  @media (max-width: 43em) {
    font-size: 24px;
  }
`

const SearchResults = (): JSX.Element => {
  const { query } = useSearchBox()
  const [noVideoResults, setNoVideoResults] = React.useState(false)
  const [noUserResults, setNoUserResults] = React.useState(false)
  const [, setOpen] = useAtom(rwMobileSearchAtom)

  return (
    <OuterDiv>
      <Index indexName="videos">
        <VideoHits setNoResults={setNoVideoResults} onClick={() => setOpen(false)} />
      </Index>
      <Index indexName="users">
        <UserHits setNoResults={setNoUserResults} query={query} onClick={() => setOpen(false)} />
      </Index>
      {noVideoResults && noUserResults && <NoResults>No results</NoResults>}
    </OuterDiv>
  )
}

export default SearchResults
